// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-migrate-to-workbook-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 32px);
}
.dl-migrate-to-workbook-dialog__body {
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;
  overflow-y: auto;
}
.dl-migrate-to-workbook-dialog__error-block {
  max-width: 100%;
}
.dl-migrate-to-workbook-dialog__error-block .error-content__debug-info {
  width: 100%;
}
.dl-migrate-to-workbook-dialog__error {
  flex: 1;
  align-self: center;
  justify-self: center;
  margin: 20px;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/MigrateToWorkbookDialog/MigrateToWorkbookDialog.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AACJ;AACI;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gBAAA;AACR;AAEI;EACI,eAAA;AAAR;AAEQ;EACI,WAAA;AAAZ;AAII;EACI,OAAA;EACA,kBAAA;EACA,oBAAA;EACA,YAAA;AAFR","sourcesContent":[".dl-migrate-to-workbook-dialog {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  max-height: calc(100vh - 32px);\n}\n.dl-migrate-to-workbook-dialog__body {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 32px;\n  overflow-y: auto;\n}\n.dl-migrate-to-workbook-dialog__error-block {\n  max-width: 100%;\n}\n.dl-migrate-to-workbook-dialog__error-block .error-content__debug-info {\n  width: 100%;\n}\n.dl-migrate-to-workbook-dialog__error {\n  flex: 1;\n  align-self: center;\n  justify-self: center;\n  margin: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
